var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup11653(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#4E4F54"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2425 66.7659V59.2226C34.2425 56.7168 36.0792 54.4692 38.6892 54.4692C41.0334 54.4692 43.1358 56.4326 43.1358 59.2226V66.4818C43.1358 71.5193 39.2208 75.7043 34.5083 75.7043C29.7958 75.7043 25.8808 71.4934 25.8808 66.4818V50.5684C25.615 36.05 36.345 24.2959 49.9267 24.2959C63.5083 24.2959 74.2141 36.0501 74.2141 50.2842V66.1976C74.2141 71.2352 70.2992 75.4202 65.5867 75.4202C60.8742 75.4202 56.9592 71.2352 56.9592 66.1976V58.9385C56.9592 56.4327 58.7958 54.1851 61.4058 54.1851C63.75 54.1851 65.8525 56.1485 65.8525 58.9385V66.7659",
    stroke: "white",
    strokeWidth: 3.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5312 42.56H56.5737C56.042 42.56 55.5345 42.8958 55.2928 43.3867L53.4803 47.2617C53.2145 47.83 52.4653 47.83 52.1995 47.2617L47.7529 37.7809C47.487 37.2384 46.762 37.2125 46.4961 37.755L44.4661 41.7592C44.2245 42.25 43.7412 42.56 43.2095 42.56H41.4453",
    stroke: "white",
    strokeWidth: 3.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup11653);
export default __webpack_public_path__ + "static/media/Group 11653.c36fca15132e821e7a346dd4f1262551.svg";
export { ForwardRef as ReactComponent };